export default "__VITE_ASSET__DIT_6tUv__"